"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ref2 = _react.default.createElement("g", null, _react.default.createElement("g", {
  transform: "translate(18 18)"
}, _react.default.createElement("path", {
  d: "M161.7,166.8c-13.8,11-33.9,8.7-44.9-5.1c-11-13.8-8.7-33.9,5.1-44.9c11.7-9.3,28.2-9.3,39.9,0l11.4-14.3 c-21.7-17.3-53.3-13.7-70.6,7.9c-17.3,21.7-13.7,53.3,7.9,70.6c18.3,14.6,44.3,14.6,62.6,0L161.7,166.8z"
})), _react.default.createElement("g", {
  transform: "translate(34 34)"
}, _react.default.createElement("path", {
  d: "M157.6,186.5c-33.5,17.6-74.9,4.7-92.5-28.8C47.6,124.1,60.5,82.7,94,65.2s74.9-4.7,92.5,28.8 c14.6,27.9,8.3,62.2-15.2,83.1l12.1,13.7c35.9-31.8,39.2-86.6,7.4-122.5C159,32.4,104.2,29.1,68.3,60.9 c-35.9,31.8-39.2,86.6-7.4,122.5c26.5,29.9,69.9,37.8,105.2,19.3L157.6,186.5z"
})), _react.default.createElement("g", {
  transform: "translate(50 50)"
}, _react.default.createElement("path", {
  d: "M208,72.6c20.5,54.2-6.8,114.9-61,135.4c-54.2,20.5-114.8-6.8-135.4-61C-9,92.8,18.3,32.2,72.6,11.6 c45.2-17.1,96.2-1.2,123.7,38.6l15-10.4C172.6-16.2,95.8-30.3,39.8,8.3C-16.3,47-30.3,123.8,8.3,179.8 c38.7,56,115.4,70.1,171.5,31.5c46.7-32.2,65.4-92.1,45.3-145.2L208,72.6z"
})), _react.default.createElement("g", {
  transform: "translate(66 66)"
}, _react.default.createElement("path", {
  d: "M28-31.5c69.2-36.3,154.8-9.6,191.1,59.6c36.3,69.2,9.6,154.8-59.6,191.1c-69.2,36.3-154.8,9.6-191.1-59.6 C-61.8,101.9-48.8,31,0-12.1l-12.1-13.7c-66.1,58.5-72.2,159.5-13.7,225.6c58.5,66.1,159.5,72.2,225.6,13.7 c66.1-58.5,72.2-159.5,13.7-225.6c-48.7-55-128.8-69.7-193.9-35.6L28-31.5z"
})));

var CalicoLogo = function CalicoLogo(_ref) {
  var className = _ref.className,
      style = _ref.style;
  return _react.default.createElement("svg", {
    className: className,
    style: style,
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 319.6 319.6",
    enableBackground: "new 0 0 319.6 319.6"
  }, _ref2);
};

var _default = CalicoLogo;
exports.default = _default;